import React from 'react';
import { PropInfo, CodeExample, SelectWrapperProps } from '@cimpress/react-components';
import SelectWrapperCode from '!raw-loader!./selectwrapper.jsx';
import SelectWrapperDemo from './selectwrapper.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const SelectWrapperDocs = () => {
  const propInfos: PropInfo<SelectWrapperProps>[] = [
    {
      name: 'containerClassName',
      type: 'string',
      default: '',
      description: 'A class name to append to the div that wraps the select component.',
    },
    {
      name: 'selectedSelect',
      type: 'function',
      default: '',
      description: 'The Select you wish to use to render the component.',
    },
    {
      name: 'helpText',
      type: 'node',
      default: '',
      description: 'Additional help text to display under the select field.',
    },
    {
      name: 'status',
      type: 'string',
      default: '',
      description: (
        <div>
          One of <code>success</code>, <code>warning</code>, or <code>error</code>, provides a validation state.
        </div>
      ),
    },
  ];

  const remarks = (
    <div>
      <p>
        Currently,{' '}
        <a href="https://github.com/bvaughn/react-virtualized-select" target="_blank" rel="noopener noreferrer">
          react-virtualized-select
        </a>{' '}
        and{' '}
        <a href="https://github.com/HubSpot/react-select-plus" target="_blank" rel="noopener noreferrer">
          react-select-plus
        </a>{' '}
        are also supported by the stylesheet. If using react-select v. 2.x.x and above as the selectedSelect, you will
        need to import the custom styles from @cimpress/react-components/lib/Select/styles and pass them to the
        SelectWrapper.
      </p>
    </div>
  );

  return (
    <ComponentDoc name="SelectWrapper" propInfos={propInfos} remarks={remarks}>
      <SelectWrapperDemo />
      <CodeExample code={SelectWrapperCode} />
    </ComponentDoc>
  );
};

export default SelectWrapperDocs;
